<script>
import Layout from "../../layouts/auth";
import { authMethods } from "@/state/helpers";
import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";
import axios from "axios";
import ErrorAlert from "@/components/errorAlert";
import { toast, variants } from "@/helpers/toaster";

/**
 * Forgot Password component
 */
export default {
  page: {
    title: "Inicijalna/zaboravljena lozinka",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {ErrorAlert, Layout },
  data() {
    return {
      isResetError: false,
      error: '',
      changePasswordForm: {
        fields: {
          new_password: {
            value: '',
            error: false,
          },
          password_confirmation: {
            value: '',
            error: false,
          },
        }
      }
    };
  },
  computed: {
    isLoading() {
      return this.$store.state.loader.loading;
    },
  },
  validations: {
    email: { required, email }
  },
  methods: {
    ...authMethods,
    async ok() {
      this.$store.commit('errorBag/CLEAR');

      try {
        this.$store.commit('loader/START_LOADING');
        await axios.post('/resetPassword', {
          email: this.$route.query.email,
          token: this.$route.query.token,
          password: this.changePasswordForm.fields.new_password.value,
          password_confirmation: this.changePasswordForm.fields.password_confirmation.value,
        })
        toast('Uspešna izmena lozinke.', variants.SUCCESS)

        await this.$router.push('/login');
      } catch (error) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <error-alert></error-alert>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft-primary">

            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Inicijalna/zaboravljena lozinka</h5>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-white">
                    <img src="@/assets/images/logo/influcent-icon-blue.png" alt height="34" />
                  </span>
                </div>
              </router-link>
            </div>
            <div class="p-2">
              <b-alert v-model="isResetError" class="mb-4" variant="danger" dismissible>{{error}}</b-alert>
              <form ref="changePasswordForm" autocomplete="off" @submit.prevent="complete">
                <div class="form-group row mb-3">
                  <label class="col-12 col-md-5 col-form-label" for="new_password">Nova lozinka:</label>
                  <div class="col-12 col-md-7">
                    <input
                        id="new_password"
                        type="password"
                        autocomplete="new-password"
                        class="form-control"
                        @input="changePasswordForm.fields.new_password.error = false"
                        :class="{'is-invalid': changePasswordForm.fields.new_password.error}"
                        name="new_password"
                        v-model="changePasswordForm.fields.new_password.value"
                    />
                  </div>
                </div>
        
                <div class="form-group row mb-3">
                  <label class="col-12 col-md-5 col-form-label" for="password_confirmation">Ponovi novu lozinku:</label>
                  <div class="col-12 col-md-7">
                    <input
                        id="password_confirmation"
                        type="password"
                        autocomplete="new-password"
                        class="form-control"
                        @input="changePasswordForm.fields.password_confirmation.error = false"
                        :class="{'is-invalid': changePasswordForm.fields.password_confirmation.error}"
                        name="current_password"
                        v-model="changePasswordForm.fields.password_confirmation.value"
                    />
                  </div>
                </div>
        
                <div class="form-group text-right mt-3">
                  <div class="row align-items-middle justify-content-middle">
                    <div class="col-12">
                      <b-button @click="ok" variant="primary" class="btn px-4 ml-2" >Snimi</b-button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>
            <router-link tag="a" to="/login" class="font-weight-medium text-primary">Nazad na prijavu</router-link>
          </p>
          <p>
            © {{ new Date().getFullYear() }} Anytime Bigz
          </p>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
